/**
 * 🆕 [Phase 85 Sprint 1 — 2026-06-23] Labels FR-CA + couleurs des 2 statuts paiement.
 *
 * Source de vérité pour l'affichage des badges paiement dépôt + paiement final.
 * Cohérent avec backend/lib/statuts_paiement.py.
 *
 * Palette cohérente :
 *   - Dépôt : tons BLEU (information neutre)
 *   - Final : tons VERT (encaissement)
 *   - États "à envoyer" : amber/orange (action requise)
 *   - États "envoyée non payée" : rose/red (à relancer)
 *   - États "payé" : vert (objectif atteint)
 *   - États "non requis/applicable" : caché par défaut
 */

export const STATUT_PAIEMENT_DEPOT_LABELS = {
  non_requis: 'Dépôt non requis',
  facture_a_envoyer: 'Facture dépôt à envoyer',
  facture_envoyee: 'Dépôt envoyé — attente paiement',
  partiel: 'Dépôt partiel',
  paye: 'Dépôt payé',
};

export const STATUT_PAIEMENT_DEPOT_COLORS = {
  non_requis: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  facture_a_envoyer: 'bg-amber-100 text-amber-800 border-amber-300',
  facture_envoyee: 'bg-rose-100 text-rose-800 border-rose-300',
  partiel: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  paye: 'bg-emerald-100 text-emerald-800 border-emerald-300',
};

export const STATUT_PAIEMENT_FINAL_LABELS = {
  non_applicable: 'Final non applicable',
  facture_a_envoyer: 'Facture finale à envoyer',
  facture_envoyee: 'Final envoyée — attente paiement',
  partiel: 'Paiement final partiel',
  paye: 'Paiement final reçu',
};

export const STATUT_PAIEMENT_FINAL_COLORS = {
  non_applicable: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  facture_a_envoyer: 'bg-amber-100 text-amber-800 border-amber-300',
  facture_envoyee: 'bg-rose-100 text-rose-800 border-rose-300',
  partiel: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  paye: 'bg-emerald-100 text-emerald-800 border-emerald-300',
};


/** Helper : retourne true si le badge dépôt doit être affiché (pas "non_requis"). */
export function shouldShowDepotBadge(statut) {
  return statut && statut !== 'non_requis';
}


/** Helper : retourne true si le badge final doit être affiché (pas "non_applicable"). */
export function shouldShowFinalBadge(statut) {
  return statut && statut !== 'non_applicable';
}


/** Helper : retourne le label FR-CA depuis le code statut paiement dépôt. */
export function getDepotLabel(statut) {
  return STATUT_PAIEMENT_DEPOT_LABELS[statut] || statut || '';
}


/** Helper : retourne le label FR-CA depuis le code statut paiement final. */
export function getFinalLabel(statut) {
  return STATUT_PAIEMENT_FINAL_LABELS[statut] || statut || '';
}


/** Helper : retourne la classe Tailwind depuis le code statut paiement dépôt. */
export function getDepotColor(statut) {
  return STATUT_PAIEMENT_DEPOT_COLORS[statut] || STATUT_PAIEMENT_DEPOT_COLORS.non_requis;
}


/** Helper : retourne la classe Tailwind depuis le code statut paiement final. */
export function getFinalColor(statut) {
  return STATUT_PAIEMENT_FINAL_COLORS[statut] || STATUT_PAIEMENT_FINAL_COLORS.non_applicable;
}
